export function AshdownOrdersService (
  $translate,
  API,
  confirm,
  sessionObjAPI
) {
  var AshdownOrders = function () {
    this.origin = sessionObjAPI.base().origin;
  };

  AshdownOrders.prototype.buildItemParams = function (order) {
    var params = {};

    angular.forEach(order.purchase_order_items_attributes, (item, idx) => {
      if (item.ashdown_ingram_sku) {
        params[`NEW_ITEM-EXT_PRODUCT_ID[${idx + 1}]`] = item.ashdown_ingram_sku;
        params[`NEW_ITEM-CUST_FIELD13[${idx + 1}]`]   = item.item_code;
        params[`NEW_ITEM-QUANTITY[${idx + 1}]`]       = parseInt(item.quantity_ordered);
        params[`NEW_ITEM-PRICE[${idx + 1}]`]          = item.unit_cost;
        params[`NEW_ITEM-CUST_FIELD12[${idx + 1}]`]   = idx + 1;
      }
    });

    return params;
  };

  AshdownOrders.prototype.buildParams = function (order) {
    const self = this;

    var queryString = {
      hookUrl          : self.hookUrl(order),
      HOOKURL          : `${API.url}/purchase_orders/ashdown_ingram/${order.id}`,
      order_number     : order.order_number,
      purchase_order_id: order.id,
      type             : 'po submit'
    };

    queryString['NEW_ITEM-CUST_FIELD5[1]']  = order.order_number;
    queryString['NEW_ITEM-CUST_FIELD6[1]']  = '';
    queryString['NEW_ITEM-CUST_FIELD11[1]'] = sessionObjAPI.countrySettings().price_includes_tax ? 'Inc': 'Ex';
    queryString['NEW_ITEM-CUST_FIELD11[1]'] = 'Inc';

    angular.extend(queryString, self.buildItemParams(order));

    return $.param(queryString);

  };

  AshdownOrders.prototype.hookUrl = function (order) {
    const self = this;

    return `${self.origin}workshop.html#/${order.vendor_id}/purchase_order/${order.id}`;
  };

  AshdownOrders.prototype.sendOrder = function (order) {
    const self = this;

    var message, type;
    var queryString = self.buildParams(order);
    var atRiskItems = order.purchase_order_items_attributes.filter(item => !item.ashdown_ingram_sku);

    if (atRiskItems.length === 1) {
      message = $translate.instant('JS_SPACE.INTEGRATIONS.ONE_ITEM_NOT_PRODUCT', { name: 'Ashdown Ingram' });
      type = 'warning';
    }
    else if (atRiskItems.length > 1) {
      message = $translate.instant('JS_SPACE.INTEGRATIONS.OVER_ONE_ITEM_NOT_PRODUCT', { num: atRiskItems.length, name: 'Ashdown Ingram' });
      type = 'warning';
    }
    else {
      message = $translate.instant('JS_SPACE.INTEGRATIONS.CONFIRM_SAVE_AND_SEND', { name: 'Ashdown Ingram' });
    }

    return confirm.generic(message, type)
    .then(() => queryString);
  };

  return AshdownOrders;
}
